import type { ActivityContentCompanyOwnerRemoving } from "@/api";
import type { Activity } from "@/models/activities";

import type { ActivityHandler } from "../interfaces";

import { firstName } from "@/models/people";
import React from "react";
import { Trans } from "../i18n";
import i18n from "@/i18n";
import { activityAuthorName } from "../feedItemLinks";

const CompanyOwnerRemoving: ActivityHandler = {
  pageHtmlTitle(_activity: Activity) {
    throw new Error("Not implemented");
  },

  pagePath(paths, _activity: Activity) {
    return paths.companyAdminPath();
  },

  PageTitle(_props: { activity: any }) {
    throw new Error("Not implemented");
  },

  PageContent(_props: { activity: Activity }) {
    throw new Error("Not implemented");
  },

  PageOptions(_props: { activity: Activity }) {
    return null;
  },

  FeedItemTitle({ activity }: { activity: Activity; page: any }) {
    const person = content(activity).person;

    if (person) {
      return (
        <Trans
          i18nKey="{{author}} removed {{personName}} as an account owner"
          values={{ author: activityAuthorName(activity), personName: firstName(person) }}
        />
      );
    }

    return <Trans i18nKey="{{author}} removed an account owner" values={{ author: activityAuthorName(activity) }} />;
  },

  FeedItemContent(_props: { activity: Activity; page: any }) {
    return null;
  },

  feedItemAlignment(_activity: Activity): "items-start" | "items-center" {
    return "items-center";
  },

  commentCount(_activity: Activity): number {
    throw new Error("Not implemented");
  },

  hasComments(_activity: Activity): boolean {
    throw new Error("Not implemented");
  },

  NotificationTitle(_activity: { activity: Activity }) {
    return i18n.t("Revoked your account owner status");
  },

  NotificationLocation({ activity }: { activity: Activity }) {
    return content(activity).company!.name!;
  },
};

function content(activity: Activity): ActivityContentCompanyOwnerRemoving {
  return activity.content as ActivityContentCompanyOwnerRemoving;
}

export default CompanyOwnerRemoving;
